import { OrderLine, OrderLineCustomerUploadEnum } from '../model'

export type UploadProduct = OrderLine & { id: number }

export const getUploadProducts = (products?: OrderLine[] | null): UploadProduct[] =>
    (products || []).filter(
        (product): product is UploadProduct =>
            typeof product.id === 'number' &&
            (product.customerUpload === OrderLineCustomerUploadEnum.Optional ||
                product.customerUpload === OrderLineCustomerUploadEnum.Required)
    )
